import { doc, setDoc, collection, getDocs } from 'firebase/firestore';
import { db } from './firebase';

// Change a user's role
export const changeUserRole = async (userId, newRole) => {
  try {
    const userRef = doc(db, 'users', userId);
    await setDoc(userRef, { role: newRole }, { merge: true });
    console.log(`✅ User role changed to: ${newRole}`);
    return true;
  } catch (error) {
    console.error('❌ Error changing user role:', error);
    return false;
  }
};

// Change user role by email
export const changeUserRoleByEmail = async (email, newRole) => {
  try {
    // First, find the user by email
    const usersRef = collection(db, 'users');
    const snapshot = await getDocs(usersRef);
    
    for (const doc of snapshot.docs) {
      const userData = doc.data();
      if (userData.email === email) {
        // Change the role
        await setDoc(doc(db, 'users', doc.id), { role: newRole }, { merge: true });
        console.log(`✅ User ${email} role changed to: ${newRole}`);
        return true;
      }
    }
    
    console.log('❌ User not found with email:', email);
    return false;
  } catch (error) {
    console.error('❌ Error changing user role by email:', error);
    return false;
  }
};

// Quick fix for your specific case
export const fixDmcalldayAccount = async () => {
  try {
    const success = await changeUserRoleByEmail('dmcallday1234@yahoo.com', 'team_captain');
    if (success) {
      console.log('✅ dmcallday1234@yahoo.com is now a team captain!');
    } else {
      console.log('❌ Failed to change role for dmcallday1234@yahoo.com');
    }
    return success;
  } catch (error) {
    console.error('❌ Error fixing dmcallday account:', error);
    return false;
  }
};

// Direct admin revocation by user ID
export const revokeAdminPrivileges = async (userId) => {
  try {
    const { doc, updateDoc } = await import('firebase/firestore');
    const { db } = await import('./firebase');
    
    const userRef = doc(db, 'users', userId);
    await updateDoc(userRef, {
      role: 'host',
      adminRevokedAt: new Date(),
      adminRevokedBy: 'admin_utility'
    });
    
    console.log(`✅ Admin privileges revoked for user: ${userId}`);
    return true;
  } catch (error) {
    console.error('❌ Error revoking admin privileges:', error);
    return false;
  }
};

// Direct role change by user ID
export const changeUserRoleById = async (userId, newRole) => {
  try {
    const { doc, updateDoc } = await import('firebase/firestore');
    const { db } = await import('./firebase');
    
    const userRef = doc(db, 'users', userId);
    await updateDoc(userRef, {
      role: newRole,
      roleChangedAt: new Date(),
      roleChangedBy: 'admin_utility'
    });
    
    console.log(`✅ User ${userId} role changed to: ${newRole}`);
    return true;
  } catch (error) {
    console.error('❌ Error changing user role:', error);
    return false;
  }
}; 